export const CustomMessages = {
  ja: {
    messages: {
      required: function (field) {
        return `「${field}」 を入力してください。`
      },
      numeric: function (field) {
        return `数字で入力してください。`
      },
      decimal: function (field, num) {
        return `${num}桁以下の小数で入力してください。`
      },
      email: function (field) {
        return `メールのフォーマットが正しくありません。`
      },
      min: function (field, num) {
        return `「${field}」は${num}文字以上でなければなりません。`
      },
      max: function (field, num) {
        return `「${field}」は${num}文字以内を入力してください。`
      },
      min_value: function (field, num) {
        return `「${field}」は${num}以上でなければなりません。`
      },
      max_value: function (field, num) {
        return `「${field}」は${num}以内を入力してください。`
      },
      alpha_num: function (field) {
        return `「${field}」は 英数字で入力してください。`
      },
      length: function (field, num) {
        return `「${field}」は${num}桁でなければなりません。`
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/validation/custom-messages.js